<!--sidebar-->
<c-sidebar #sidebar="cSidebar" class="d-print-none sidebar sidebar-fixed flex flex-col" id="sidebar" visible>
    <c-sidebar-brand routerLink="./" class="w-fit h-fit bg-white">
        <div>
            <img src="assets/img/brand/logo.jpg" alt="KCB Logo" class="object-contain w-full h-full p-1" />
        </div>
    </c-sidebar-brand>

    <div class="sidebar-scroll-content">
        <c-sidebar-nav [navItems]="navItems" dropdownMode="none"> </c-sidebar-nav>
    </div>
    <div
    class="flex items-center justify-center text-xs gap-1 p-2 bg-copyright shadow-sm mt-auto">
    <a href="https://whiteneurons.com/"
        class="capitalize font-medium transition duration-300 no-underline">
            © 2026 White Neuron
        </a>
    </div>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
    <app-maintenance-popup></app-maintenance-popup>
    <!--app-header-->
    <app-default-header
        class="mb-4 d-print-none header header-sticky"
        position="sticky"
        sidebarId="sidebar"
    ></app-default-header>
    <!--app-body-->
    <div class="body flex-grow-1 px-4">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Scroll to top and bottom, nằm bên phải màn hình, và ở giữa chiều -->
<!-- <div class="scroll-container" *ngIf="!isChatbotRoute">
    <button class="scroll-top" [ngClass]="{'open': isShow}" (click)="scrollToTop()">
        <i class="fas fa-angle-double-up"></i>
    </button>
    <button class="scroll-down scroll-to-target open" [ngClass]="{'open': !isBottom}" (click)="scrollToBottom()">
        <i class="fas fa-angle-double-down"></i>
    </button>
</div> -->
